import React, { Fragment } from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  DobAttachments,
  DobNotes,
  JobAias,
  JobAttachments,
  JobContacts,
  JobDrawings,
  JobFinancialSummary,
  JobAgreements,
  JobFollowUps,
  JobInvoices,
  JobNotes,
  JobPaymentRequests,
  JobSiteChangeOrders,
  JobSiteDocuments,
  JobSiteDriverRequests,
  JobSiteEstimates,
  JobSiteJobMinutes,
  JobSiteMaterialRequests,
  JobSiteOverview,
  JobSitePurchaseOrders,
  JobSiteRFIs,
  JobSiteTransmittals,
  JobSiteWorkOrders,
  JobSiteServiceOrders,
  JobVendors,
  JobParts,
  ScheduleDrawings,
  ScheduleApplications,
  ScheduleManufacturing,
  ScheduleSiteWork,
  ScheduleRepair,
  JobStopCalls,
  JobSiteTickets,
  Violations,
  Testing
} from '../containers/job/tasks'

//TODO change to job/
const prefix = '/jobView/:jobId/:jobType'

const JobRoutes = jobRouteProps => (
  <Fragment>
    <Route
      path={`${prefix}/driver-requests`}
      render={props => <JobSiteDriverRequests {...props} {...jobRouteProps} />}
    />
    <Route
      path={`${prefix}/attachments`}
      render={props => <JobAttachments {...props} {...jobRouteProps} />}
    />
    <Route
      path={`${prefix}/follow-ups`}
      render={props => <JobFollowUps {...props} {...jobRouteProps} />}
    />

    <Route path={`${prefix}/notes`} render={props => <JobNotes {...props} {...jobRouteProps} />} />

    <Route
      path={`${prefix}/contacts`}
      render={props => <JobContacts {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/schedule-drawings`}
      render={props => <ScheduleDrawings {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/manufacturing`}
      render={props => <ScheduleManufacturing {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/applications`}
      render={props => <ScheduleApplications {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/sitework`}
      render={props => <ScheduleSiteWork {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/financial-summary`}
      render={props => <JobFinancialSummary {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/payment-requests`}
      render={props => <JobPaymentRequests {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/agreements`}
      render={props => <JobAgreements {...props} {...jobRouteProps} />}
    />

    <Route path={`${prefix}/aias`} render={props => <JobAias {...props} {...jobRouteProps} />} />

    <Route
      path={`${prefix}/invoices`}
      render={props => <JobInvoices {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/drawings`}
      render={props => <JobDrawings {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/vendors`}
      render={props => <JobVendors {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/vendors/puchase-order/modal/:purchaseOrderId`}
      render={props => <JobVendors {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/dob-attachments`}
      render={props => <DobAttachments {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/dob-notes`}
      render={props => <DobNotes {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/violations`}
      render={props => <Violations {...props} {...jobRouteProps} />}
    />

    <Route path={`${prefix}/testing`} render={props => <Testing {...props} {...jobRouteProps} />} />

    <Route
      path={`${prefix}/site-overview`}
      render={props => <JobSiteOverview {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/material-requests`}
      render={props => <JobSiteMaterialRequests {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/work-orders`}
      render={props => <JobSiteWorkOrders {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/service-orders`}
      render={props => <JobSiteServiceOrders {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/purchase-orders`}
      render={props => <JobSitePurchaseOrders {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/change-orders`}
      render={props => (
        <JobSiteChangeOrders {...props} {...jobRouteProps} title="Job Site Change Orders" />
      )}
    />

    <Route
      path={`${prefix}/repair-orders`}
      render={props => (
        <JobSiteChangeOrders {...props} {...jobRouteProps} title="Job Site Repair Orders" />
      )}
    />

    <Route
      path={'/jobView/:jobId/:jobType/site-estimates'}
      render={props => <JobSiteEstimates {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/site-documents`}
      render={props => <JobSiteDocuments {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/minutes`}
      render={props => <JobSiteJobMinutes {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/transmittals`}
      render={props => <JobSiteTransmittals {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/site-rfi`}
      render={props => <JobSiteRFIs {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/site-tickets`}
      render={props => <JobSiteTickets {...props} {...jobRouteProps} />}
    />

    <Route path={`${prefix}/parts`} render={props => <JobParts {...props} {...jobRouteProps} />} />

    <Route
      path={`${prefix}/stop-calls`}
      render={props => <JobStopCalls {...props} {...jobRouteProps} />}
    />

    <Route
      path={`${prefix}/schedule-repair`}
      render={props => <ScheduleRepair {...props} {...jobRouteProps} />}
    />
  </Fragment>
)

const mapStateToProps = state => ({
  user: state.authentication.user
})

export default connect(mapStateToProps)(JobRoutes)



// WEBPACK FOOTER //
// ./src/components/JobRoutes.js